import { render } from "./kalio-perk-redeem-instructions-modal.vue?vue&type=template&id=83f423c4"
import script from "./kalio-perk-redeem-instructions-modal.vue?vue&type=script&lang=js"
export * from "./kalio-perk-redeem-instructions-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__